const initialState = {
  saving: false,
  lastSaved: null,
  saveError: '',
  confirmationNumber: '',
  errors: [],
  submittedFlag: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case 'SET_ENROLLMENT_FIELD':
      return { ...state, ...action.payload };
    case 'SET_ENROLLMENT_SAVING':
      return { ...state, saving: action.saving };
    case 'SET_ENROLLMENT_SAVING_ERROR':
      return { ...state, saveError: action.error };
    case 'SET_ENROLLMENT_LAST_SAVED':
      return { ...state, lastSaved: action.time };
    case 'CLEAR_ENROLLMENT':
      return initialState;
    case 'CLEAR':
      return initialState;
    default:
      return state;
  }
}
